// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2xkj0","dragIcon":"Choice_dragIcon__Ztfql","left":"Choice_left__2ky13","input":"Choice_input__3fBGw"};